import { useState } from 'react';
import { ErrorMessage, Field } from 'formik';
import { Eye, EyeOff } from 'lucide-react';
import { formatSsnInput, validateSsn } from '../helper';

const PolicyHolderSsn = () => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="form-control">
      <label className="label pb-1.5">
        <span className="label-text font-medium">Policy holder's SSN</span>
        <span className="label-text-alt text-base-content/40 font-normal normal-case text-xs">Optional</span>
      </label>

      <div className="relative">
        <Field name="policy_holder_ssn" validate={validateSsn}>
          {({ field, form }) => (
            <input
              {...field}
              onChange={(e) => form.setFieldValue(field.name, formatSsnInput(e.target.value))}
              type={visible ? 'text' : 'password'}
              inputMode="numeric"
              autoComplete="off"
              spellCheck={false}
              maxLength={11}
              placeholder="123-45-6789"
              className="input input-bordered w-full pr-11"
            />
          )}
        </Field>

        <button
          type="button"
          onClick={() => setVisible(!visible)}
          aria-label={visible ? 'Hide SSN' : 'Show SSN'}
          className="absolute inset-y-0 right-0 flex w-11 items-center justify-center text-secondary-400 hover:text-secondary-700"
        >
          {visible ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      </div>

      <ErrorMessage name="policy_holder_ssn" render={(msg) => (
        <label className="label pt-1">
          <span className="label-text-alt text-error">{msg}</span>
        </label>
      )} />

      <span className="mt-1.5 text-xs text-secondary-400">Helps us verify coverage with your carrier.</span>
    </div>
  );
};

export default PolicyHolderSsn;
